import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import LaunchIcon from "@mui/icons-material/Launch"
import { IconButton } from "@mui/material"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"

const StudentCard = ({ data }) => (
  <CardContainer
    disableEditDelete
    SummaryContent={
      <>
        <CardStat label="Institute Id" value={data?.instituteId} />
        <CardStat label="Name" value={data?.user_?.name} />
        <CardStat label="Program" value={data?.program} />
        <CardStat label="Year" value={data?.year} />
      </>
    }
    DetailsContent={
      <>
        <CardStat label="Father's name" value={data?.fatherName} />
        {/* <CardStat label="Username" value={data?.user_?.username} /> */}
        <CardStat label="Phone Number" value={data?.user_?.phoneNumber} />
        <CardStat label="Email" value={data?.user_?.email} />
      </>
    }
    ActionButtons={
      <Link to={`${routes.ADMIN.STUDENTS}/${data?.studentUser}`}>
        <IconButton>
          <LaunchIcon />
        </IconButton>
      </Link>
    }
  />
)

export default StudentCard
